import React from 'react'
import './AIHero.scss'

export class AIHero extends React.Component {
  render() {
    return (
      <div
        className="ai-page-hero"
        style={{ backgroundImage: 'url(/cloudsecopsbg.jpg)' }}
      >
        <div className="overlay" />
        <div className="inner-wrap">
          <div className="text">
            <h1>AI & Machine Learning</h1>
            <h2>Production-Grade AI Systems for Mission-Critical Federal Environments</h2>
          </div>
        </div>
      </div>
    )
  }
}

export default AIHero
